(function () {
  const uuid = () =>
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });

  const parseIntSafe = (val, fallback) => {
    const n = parseInt(String(val), 10);
    return Number.isNaN(n) ? fallback : n;
  };

  const miniCompare = (ds, key) => {
    const v = ds[key];
    if (v === undefined || v === null || v === '') return null;
    const n = parseInt(String(v), 10);
    return Number.isNaN(n) ? null : n;
  };

  const fixMediaWidth = (url, width) => {
    if (!url || typeof url !== 'string') return url;
    return url.replace(/(\?v=[\w\d]+)&width=\d+\b/g, `$1&width=${width}`);
  };

  const preloadImage = (src) =>
    new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve();
      img.onerror = () => resolve();
      img.src = src;
    });

  const preloadVideo = (src) =>
    new Promise((resolve) => {
      const video = document.createElement('video');
      video.preload = 'auto';
      video.muted = true;
      video.playsInline = true;
      const onReady = () => resolve();
      video.addEventListener('loadeddata', onReady, { once: true });
      video.addEventListener('error', onReady, { once: true });
      video.src = src;
      video.load();
    });

  const preloadGalleryMedia = (items) => {
    const loads = [];
    items.forEach((item) => {
      if (item.type === 'video') {
        loads.push(preloadVideo(fixMediaWidth(item.src, 500)));
        loads.push(preloadVideo(fixMediaWidth(item.src, 1500)));
        return;
      }
      loads.push(preloadImage(fixMediaWidth(item.src, 320)));
      loads.push(preloadImage(fixMediaWidth(item.src, 1500)));
    });
    return Promise.all(loads);
  };

  class CclpEpdpHero extends HTMLElement {
    connectedCallback() {
      const el = this;
      const sectionId = el.dataset.sectionId;
      if (!sectionId) return;
      if (el._cclpEpdpConnected) return;
      el._cclpEpdpConnected = true;

      const BUY_BOX_MODE = el.dataset.buyBoxMode || 'standard_only';
      const USE_MB_SET_BUILDER = el.dataset.useMbSetBuilder === 'true';
      const MINI_ENABLED = BUY_BOX_MODE === 'standard_and_mini' || BUY_BOX_MODE === 'mini_only';
      const STANDARD_PRICE = el.dataset.standardPrice || '$38';
      const STANDARD_CTA_ACTION = el.dataset.standardCtaAction || 'add_to_cart';
      const CTA_LINK = el.dataset.ctaUrl || '';
      const LEAD_IMAGE_INDEX = parseInt(el.dataset.leadImageIndex, 10) || 0;

      this._mouseHandler = () => {
        document.body.classList.add('has-mouse');
      };
      document.addEventListener('mousemove', this._mouseHandler, { once: true });

      const galleryMainWrap = el.querySelector('[data-cclp-epdp-main-wrap]');
      const galleryThumbs = el.querySelector('[data-cclp-epdp-thumbs]');

      if (USE_MB_SET_BUILDER) {
        const mbMediaHook = el.querySelector(`.js-productMedia[data-cclp-epdp-media="${sectionId}"]`);
        let mbActiveIndex = 0;

        const parseSlideMedia = (slide) => {
          const video = slide.querySelector('video');
          if (video) {
            const source = video.querySelector('source');
            const src = source ? source.getAttribute('src') : '';
            const type = source ? source.getAttribute('type') : 'video/mp4';
            const ext = type.indexOf('/') > -1 ? type.split('/')[1] : 'mp4';
            return src ? { type: 'video', src, extension: ext } : null;
          }
          const img = slide.querySelector('img.aspect-child, img');
          return img && img.getAttribute('src') ? { type: 'image', src: img.getAttribute('src') } : null;
        };

        const renderMainMedia = (item) => {
          if (!galleryMainWrap || !item) return;
          const mainId = `cclpEpdpHeroMainImg-${sectionId}`;
          if (item.type === 'video') {
            galleryMainWrap.innerHTML =
              `<video class="cclp-epdp-hero__gallery-main" id="${mainId}" muted loop playsinline autoplay disablepictureinpicture disableremoteplayback>` +
              `<source src="${fixMediaWidth(item.src, 1500)}" type="video/${item.extension || 'mp4'}">` +
              '</video>';
            const vid = galleryMainWrap.querySelector('video');
            if (vid) vid.play().catch(() => {});
          } else {
            const src = fixMediaWidth(item.src, 1500);
            galleryMainWrap.innerHTML =
              `<img class="cclp-epdp-hero__gallery-main" id="${mainId}" src="${src}" alt="" data-default-src="${src}">`;
          }
        };

        const renderThumbs = (items) => {
          if (!galleryThumbs) return;
          if (items.length <= 1) {
            galleryThumbs.style.display = 'none';
            galleryThumbs.innerHTML = '';
            return;
          }
          galleryThumbs.style.display = '';
          galleryThumbs.innerHTML = '';
          if (mbActiveIndex >= items.length) mbActiveIndex = 0;

          items.forEach((item, i) => {
            const wrap = document.createElement('div');
            wrap.className = `cclp-epdp-hero__thumb-wrap${i === mbActiveIndex ? ' is-active' : ''}`;
            if (item.type === 'video') {
              wrap.innerHTML =
                '<video class="cclp-epdp-hero__thumb" muted loop playsinline autoplay disablepictureinpicture disableremoteplayback>' +
                `<source src="${fixMediaWidth(item.src, 500)}" type="video/${item.extension || 'mp4'}">` +
                '</video>';
            } else {
              const thumbSrc = fixMediaWidth(item.src, 320);
              const fullSrc = fixMediaWidth(item.src, 1500);
              wrap.innerHTML =
                `<img class="cclp-epdp-hero__thumb" src="${thumbSrc}" data-full="${fullSrc}" alt="Product image ${i + 1}">`;
            }
            wrap.addEventListener('click', () => {
              mbActiveIndex = i;
              renderMainMedia(item);
              galleryThumbs.querySelectorAll('.cclp-epdp-hero__thumb-wrap').forEach((w, wi) => {
                w.classList.toggle('is-active', wi === i);
              });
            });
            galleryThumbs.appendChild(wrap);
            if (item.type === 'video') {
              const thumbVid = wrap.querySelector('video');
              if (thumbVid) thumbVid.play().catch(() => {});
            }
          });
        };

        const syncGalleryFromMbHook = () => {
          if (!mbMediaHook) return;
          const items = [];
          mbMediaHook.querySelectorAll('.js-productMediaSlide').forEach((slide) => {
            const parsed = parseSlideMedia(slide);
            if (parsed) items.push(parsed);
          });
          if (!items.length) return;

          mbActiveIndex = 0;
          if (galleryMainWrap) galleryMainWrap.style.visibility = 'hidden';
          if (galleryThumbs && items.length > 1) galleryThumbs.style.visibility = 'hidden';

          preloadGalleryMedia(items).then(() => {
            renderThumbs(items);
            renderMainMedia(items[0]);
            if (galleryMainWrap) galleryMainWrap.style.visibility = '';
            if (galleryThumbs) galleryThumbs.style.visibility = '';
          });
        };

        this._mbGallerySyncHandler = () => {
          if (!mbMediaHook || !el.contains(mbMediaHook)) return;
          syncGalleryFromMbHook();
        };
        document.addEventListener('phn:gallery-updated', this._mbGallerySyncHandler);
        syncGalleryFromMbHook();
        setTimeout(syncGalleryFromMbHook, 0);
        return;
      }

      const heroMain = el.querySelector(`#cclpEpdpHeroMainImg-${sectionId}`);
      const thumbWraps = el.querySelectorAll('.cclp-epdp-hero__thumb-wrap');
      this._thumbHandlers = [];
      thumbWraps.forEach((wrap) => {
        const img = wrap.querySelector('.cclp-epdp-hero__thumb');
        const handler = () => {
          thumbWraps.forEach((w) => {
            w.classList.remove('is-active');
          });
          wrap.classList.add('is-active');
          if (heroMain && img) heroMain.src = img.getAttribute('data-full');
        };
        wrap.addEventListener('click', handler);
        el._thumbHandlers.push({ el: wrap, fn: handler });
      });

      const defaultGallery = (() => {
        const d = { main: [], thumb: [] };
        d.main.push(heroMain ? heroMain.getAttribute('data-default-src') || heroMain.src : null);
        d.thumb.push(null);
        thumbWraps.forEach((w) => {
          const img = w.querySelector('.cclp-epdp-hero__thumb');
          d.main.push(img ? img.getAttribute('data-full') || img.src : null);
          d.thumb.push(img ? img.src : null);
        });
        return d;
      })();

      const reorderForLead = (imgs) => {
        if (!LEAD_IMAGE_INDEX || LEAD_IMAGE_INDEX < 1 || LEAD_IMAGE_INDEX >= imgs.length) {
          return imgs;
        }
        const hero = imgs[LEAD_IMAGE_INDEX];
        const rest = imgs.filter((_, i) => i !== LEAD_IMAGE_INDEX);
        return [hero].concat(rest);
      };

      const applyGallery = (mainImgs, thumbImgs) => {
        if (heroMain) heroMain.src = mainImgs[0] || defaultGallery.main[0];
        thumbWraps.forEach((w, i) => {
          const img = w.querySelector('.cclp-epdp-hero__thumb');
          const fullUrl = mainImgs[i + 1] || defaultGallery.main[i + 1];
          const thumbUrl = (thumbImgs && thumbImgs[i + 1]) || defaultGallery.thumb[i + 1] || fullUrl;
          if (img) {
            if (thumbUrl) img.src = thumbUrl;
            if (fullUrl) img.setAttribute('data-full', fullUrl);
          }
          w.classList.toggle('is-active', i === 0);
        });
      };

      const swatches = el.querySelectorAll('.cclp-epdp-hero__standard-mode .cclp-epdp-hero__swatch');
      const shadeName = el.querySelector(`#cclpEpdpShadeName-${sectionId}`);
      const shadeDesc = el.querySelector(`#cclpEpdpShadeDesc-${sectionId}`);

      this._swatchHandlers = [];
      swatches.forEach((swatch) => {
        const handler = () => {
          swatches.forEach((s) => {
            s.classList.remove('is-selected');
          });
          swatch.classList.add('is-selected');
          if (shadeName) shadeName.textContent = swatch.getAttribute('data-shade');
          if (shadeDesc) shadeDesc.textContent = swatch.getAttribute('data-desc');

          const mainAttr = swatch.getAttribute('data-variant-images') || '';
          const thumbAttr = swatch.getAttribute('data-variant-images-thumb') || '';
          const rawMain = mainAttr ? mainAttr.split('|').filter(Boolean) : [];
          const rawThumb = thumbAttr ? thumbAttr.split('|').filter(Boolean) : [];
          if (rawMain.length > 0) {
            applyGallery(reorderForLead(rawMain), reorderForLead(rawThumb));
          } else {
            applyGallery(defaultGallery.main, defaultGallery.thumb);
          }
        };
        swatch.addEventListener('click', handler);
        el._swatchHandlers.push({ el: swatch, fn: handler });
      });

      const standardTabs = el.querySelectorAll('.cclp-epdp-hero__standard-mode .cclp-epdp-hero__shade-tab');
      this._tabHandlers = [];
      standardTabs.forEach((tab) => {
        const handler = () => {
          const category = tab.getAttribute('data-category');
          standardTabs.forEach((t) => {
            t.classList.remove('is-active');
          });
          tab.classList.add('is-active');
          swatches.forEach((swatch) => {
            if (category === 'all' || swatch.getAttribute('data-category') === category) {
              swatch.style.display = '';
            } else {
              swatch.style.display = 'none';
            }
          });
        };
        tab.addEventListener('click', handler);
        el._tabHandlers.push({ el: tab, fn: handler });
      });

      const ds = el.dataset;
      const MINI_PRICING = {
        1: { price: parseIntSafe(ds.miniPrice1x, 20), compare: null },
        3: {
          price: parseIntSafe(ds.miniPrice3x, 57),
          compare: miniCompare(ds, 'miniCompare3x'),
        },
        6: {
          price: parseIntSafe(ds.miniPrice6x, 108),
          compare: miniCompare(ds, 'miniCompare6x'),
        },
      };

      let currentSize = 'standard';
      let currentMiniQty = 3;

      const standardMode = el.querySelector('[data-mode="standard"]');
      const miniMode = el.querySelector('[data-mode="mini"]');
      const sizeBtns = el.querySelectorAll('.cclp-epdp-hero__size-btn');
      const qtyBtns = el.querySelectorAll('.cclp-epdp-hero__qty-btn');
      const atcPriceEl = el.querySelector('[data-cclp-epdp-atc-price]');
      const atcCompareEl = el.querySelector('[data-cclp-epdp-atc-compare]');
      const miniShadeCount = el.querySelector('[data-mini-shade-count]');
      const miniSwatchBox = el.querySelector('[data-mini-swatch-container]');
      const miniShadeItems = el.querySelectorAll('.cclp-epdp-hero__mini-shade-item');
      const miniCatTabs = el.querySelectorAll('[data-mini-category]');
      const atcBtn = el.querySelector('[data-cclp-epdp-atc]');
      const atcTextEl = atcBtn ? atcBtn.querySelector('.cclp-epdp-hero__atc-text') : null;
      const shadeList = el.querySelector('.cclp-epdp-hero__mini-shade-list');
      const scrollHint = el.querySelector('[data-mini-scroll-hint]');

      const getMiniTotalShadeQty = () => {
        let total = 0;
        miniShadeItems.forEach((item) => {
          const numEl = item.querySelector('.cclp-epdp-hero__mini-qty-num');
          total += parseInt(numEl ? numEl.textContent : '0', 10) || 0;
        });
        return total;
      };

      const updateMiniSwatchSummary = () => {
        if (!miniSwatchBox) return;
        miniSwatchBox.innerHTML = '';
        let filled = 0;
        miniShadeItems.forEach((item) => {
          const numEl = item.querySelector('.cclp-epdp-hero__mini-qty-num');
          const qty = parseInt(numEl ? numEl.textContent : '0', 10) || 0;
          if (qty > 0) {
            filled += qty;
            const color = item.getAttribute('data-shade-color') || '#ccc';
            const swatch = document.createElement('div');
            swatch.className = 'cclp-epdp-hero__mini-swatch';
            let html = `<div class="cclp-epdp-hero__mini-swatch-inner" style="background:${color};"></div>`;
            if (qty > 1) {
              html += `<div class="cclp-epdp-hero__mini-swatch-count"><span>${qty}</span></div>`;
            }
            swatch.innerHTML = html;
            miniSwatchBox.appendChild(swatch);
          }
        });
        const remaining = currentMiniQty - filled;
        for (let i = 0; i < remaining; i++) {
          const empty = document.createElement('div');
          empty.className = 'cclp-epdp-hero__mini-swatch cclp-epdp-hero__mini-swatch--empty';
          empty.innerHTML = '<div class="cclp-epdp-hero__mini-swatch-inner"></div>';
          miniSwatchBox.appendChild(empty);
        }
      };

      const updateAtcState = () => {
        if (!atcBtn) return;
        if (currentSize === 'mini') {
          const total = getMiniTotalShadeQty();
          if (total < currentMiniQty) {
            atcBtn.classList.add('is-disabled');
          } else {
            atcBtn.classList.remove('is-disabled');
          }
        } else {
          atcBtn.classList.remove('is-disabled');
        }
      };

      const setMiniQty = (qty) => {
        currentMiniQty = qty;
        const p = MINI_PRICING[qty];
        if (!p) return;

        qtyBtns.forEach((btn) => {
          btn.classList.toggle('is-active', parseInt(btn.getAttribute('data-qty'), 10) === qty);
        });

        if (atcPriceEl) atcPriceEl.textContent = `$${p.price}`;
        if (atcCompareEl) {
          if (p.compare) {
            atcCompareEl.textContent = `$${p.compare}`;
            atcCompareEl.style.display = '';
          } else {
            atcCompareEl.style.display = 'none';
          }
        }
        if (miniShadeCount) miniShadeCount.textContent = qty;

        if (getMiniTotalShadeQty() > qty) {
          miniShadeItems.forEach((item) => {
            const numEl = item.querySelector('.cclp-epdp-hero__mini-qty-num');
            if (numEl) numEl.textContent = '0';
            item.classList.remove('is-selected');
          });
        }
        updateMiniSwatchSummary();
        updateAtcState();
      };

      const setSize = (size) => {
        currentSize = size;
        sizeBtns.forEach((btn) => {
          btn.classList.toggle('is-active', btn.getAttribute('data-size') === size);
        });

        if (size === 'standard') {
          if (standardMode) standardMode.classList.remove('cclp-epdp-hero__hidden');
          if (miniMode) miniMode.classList.add('cclp-epdp-hero__hidden');
          if (atcPriceEl) atcPriceEl.textContent = STANDARD_PRICE;
          if (atcCompareEl) atcCompareEl.style.display = 'none';
        } else {
          if (standardMode) standardMode.classList.add('cclp-epdp-hero__hidden');
          if (miniMode) miniMode.classList.remove('cclp-epdp-hero__hidden');
          setMiniQty(currentMiniQty);
        }
        updateAtcState();
      };

      this._sizeHandlers = [];
      sizeBtns.forEach((btn) => {
        const handler = () => {
          setSize(btn.getAttribute('data-size'));
        };
        btn.addEventListener('click', handler);
        el._sizeHandlers.push({ el: btn, fn: handler });
      });

      this._qtyHandlers = [];
      qtyBtns.forEach((btn) => {
        const handler = () => {
          const qty = parseInt(btn.getAttribute('data-qty'), 10);
          if (qty) setMiniQty(qty);
        };
        btn.addEventListener('click', handler);
        el._qtyHandlers.push({ el: btn, fn: handler });
      });

      this._miniQtyHandlers = [];
      el.querySelectorAll('.cclp-epdp-hero__mini-qty-btn').forEach((btn) => {
        const handler = () => {
          const item = btn.closest('.cclp-epdp-hero__mini-shade-item');
          const numEl = item.querySelector('.cclp-epdp-hero__mini-qty-num');
          let val = parseInt(numEl.textContent, 10) || 0;
          const isAdd = btn.classList.contains('cclp-epdp-hero__mini-qty-btn--add');

          if (isAdd) {
            if (getMiniTotalShadeQty() >= currentMiniQty) return;
            val++;
          } else {
            if (val <= 0) return;
            val--;
          }

          numEl.textContent = val;
          item.classList.toggle('is-selected', val > 0);
          updateMiniSwatchSummary();
          updateAtcState();
        };
        btn.addEventListener('click', handler);
        el._miniQtyHandlers.push({ el: btn, fn: handler });
      });

      const updateScrollHint = () => {
        if (!shadeList || !scrollHint) return;
        const atBottom = shadeList.scrollHeight - shadeList.scrollTop - shadeList.clientHeight < 10;
        scrollHint.style.display = shadeList.scrollHeight > shadeList.clientHeight && !atBottom ? '' : 'none';
      };

      const filterMiniCategory = (cat) => {
        miniShadeItems.forEach((item) => {
          if (cat === 'all') {
            item.style.display = '';
          } else {
            item.style.display = item.getAttribute('data-shade-category') === cat ? '' : 'none';
          }
        });
        updateScrollHint();
      };

      this._miniCatHandlers = [];
      miniCatTabs.forEach((tab) => {
        const handler = () => {
          miniCatTabs.forEach((t) => {
            t.classList.remove('is-active');
          });
          tab.classList.add('is-active');
          const cat = (tab.getAttribute('data-mini-category') || 'all').toLowerCase();
          filterMiniCategory(cat);
        };
        tab.addEventListener('click', handler);
        el._miniCatHandlers.push({ el: tab, fn: handler });
      });

      if (shadeList) {
        this._scrollHandler = updateScrollHint;
        shadeList.addEventListener('scroll', this._scrollHandler, { passive: true });
        this._shadeList = shadeList;
      }
      if (scrollHint) {
        this._scrollClickHandler = () => {
          shadeList.scrollBy({ top: 200, behavior: 'smooth' });
        };
        scrollHint.addEventListener('click', this._scrollClickHandler);
        this._scrollHint = scrollHint;
      }

      if (BUY_BOX_MODE === 'mini_only') {
        currentSize = 'mini';
        setMiniQty(currentMiniQty);
      } else if (MINI_ENABLED) {
        updateMiniSwatchSummary();
      }
      updateAtcState();
      updateScrollHint();

      if (atcBtn) {
        this._atcHandler = (e) => {
          e.preventDefault();
          if (atcBtn.classList.contains('is-disabled') || atcBtn.classList.contains('is-loading')) return;

          const items = [];

          if (currentSize === 'mini') {
            const bundleId = uuid();
            const miniProductTitle = el.dataset.miniProductTitle || 'Mini Miracle Balm';
            const miniProductId = el.dataset.miniProductId || '';
            const miniProductImage = el.dataset.miniProductImage || '';
            const tierLabel = currentMiniQty === 1 ? '1 MINI' : `SET OF ${currentMiniQty}`;

            miniShadeItems.forEach((item) => {
              const numEl = item.querySelector('.cclp-epdp-hero__mini-qty-num');
              const qty = parseInt(numEl ? numEl.textContent : '0', 10) || 0;
              const variantId = item.getAttribute('data-variant-id');
              if (qty > 0 && variantId) {
                let props = {};
                if (currentMiniQty > 1) {
                  props = {
                    _bundle_id: bundleId,
                    _conditions: `${miniProductId}@${currentMiniQty}`,
                    _d: `miracle-balm-mini-set-${currentMiniQty}`,
                    _shade_quantity: tierLabel,
                    _title: item.getAttribute('data-variant-title') || '',
                    _product: miniProductTitle,
                    _product_id: miniProductId,
                    _image: miniProductImage,
                    _t: 'fix',
                    _finalSale: 'true',
                  };
                } else {
                  props = { _product: miniProductTitle };
                }
                items.push({ id: parseInt(variantId, 10), quantity: qty, properties: props });
              }
            });
          } else {
            const selectedSwatch = el.querySelector('.cclp-epdp-hero__swatch.is-selected');
            if (selectedSwatch) {
              const variantId = selectedSwatch.getAttribute('data-variant-id');
              if (variantId) {
                items.push({ id: parseInt(variantId, 10), quantity: 1 });
              }
            }
          }

          if (currentSize !== 'mini' && STANDARD_CTA_ACTION === 'link' && CTA_LINK) {
            window.location.href = CTA_LINK;
            return;
          }

          if (items.length === 0) return;

          atcBtn.classList.add('is-loading');
          const originalText = atcTextEl ? atcTextEl.textContent : '';
          if (atcTextEl) atcTextEl.textContent = 'Adding...';

          const resetBtn = () => {
            atcBtn.classList.remove('is-loading');
            if (atcTextEl) atcTextEl.textContent = originalText;
          };

          if (currentSize === 'mini' && currentMiniQty > 1) {
            const addSet = window.JR?.addSetThenOpen;
            const addPromise =
              typeof addSet === 'function'
                ? addSet(items)
                : window
                    .fetch('/cart/add.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ items }),
                    })
                    .then((res) => {
                      if (!res.ok) throw new Error(`Add to cart failed: ${res.status}`);
                      return res.json();
                    })
                    .then(() => {
                      const refreshThenOpen = window.JR?.refreshCartThenOpen;
                      if (typeof refreshThenOpen === 'function') return refreshThenOpen();
                      if (window.cartAddCallbacks) window.cartAddCallbacks.forEach((cb) => cb());
                    });

            addPromise.catch((err) => console.error('ATC error:', err)).finally(resetBtn);
          } else if (typeof window.addToCart === 'function') {
            window.addToCart({ items }, resetBtn);
          } else {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items }),
            })
              .then((res) => {
                if (!res.ok) throw new Error(`Add to cart failed: ${res.status}`);
                return res.json();
              })
              .then(() => {
                resetBtn();
                window.location.href = '/cart';
              })
              .catch((err) => {
                console.error('ATC error:', err);
                resetBtn();
              });
          }
        };
        atcBtn.addEventListener('click', this._atcHandler);
        this._atcBtn = atcBtn;
      }
    }

    disconnectedCallback() {
      if (!this._cclpEpdpConnected) return;
      this._cclpEpdpConnected = false;

      if (this._mouseHandler) {
        document.removeEventListener('mousemove', this._mouseHandler);
      }
      if (this._mbGallerySyncHandler) {
        document.removeEventListener('phn:gallery-updated', this._mbGallerySyncHandler);
      }
      const handlerLists = [
        '_thumbHandlers',
        '_swatchHandlers',
        '_tabHandlers',
        '_sizeHandlers',
        '_qtyHandlers',
        '_miniQtyHandlers',
        '_miniCatHandlers',
      ];
      for (let i = 0; i < handlerLists.length; i++) {
        const list = this[handlerLists[i]];
        if (list) {
          list.forEach((h) => {
            h.el.removeEventListener('click', h.fn);
          });
        }
      }
      if (this._shadeList && this._scrollHandler) {
        this._shadeList.removeEventListener('scroll', this._scrollHandler);
      }
      if (this._scrollHint && this._scrollClickHandler) {
        this._scrollHint.removeEventListener('click', this._scrollClickHandler);
      }
      if (this._atcBtn && this._atcHandler) {
        this._atcBtn.removeEventListener('click', this._atcHandler);
      }
    }
  }

  if (!customElements.get('cclp-epdp-hero')) {
    customElements.define('cclp-epdp-hero', CclpEpdpHero);
  }
})();
